/**
 * @file Automatically generated by barrelsby.
 */

export * from './vertical-tab.component';
